var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAccUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAccUser") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Password--ERROR",
    transform: "translate(-43.000000, -175.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(20.000000, 114.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(3.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(21.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3124491,0 C13.1646596,0 15.4770807,2.31214035 15.4770807,5.16463158 C15.4770807,8.01740351 13.1646596,10.3292632 10.3124491,10.3292632 C7.4602386,10.3292632 5.14753684,8.01740351 5.14753684,5.16463158 C5.14753684,2.31214035 7.4602386,0 10.3124491,0 Z",
    id: "Stroke-1",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5928702,16.9010526 C20.0028351,13.2117895 17.4445193,10.2113684 14.0502737,8.88364912 C13.0672561,9.86694737 11.4928,10.2113684 10.3124491,10.2113684 C9.08269474,10.2113684 7.5085193,9.86694737 6.52437895,8.88364912 C3.17981754,10.1619649 0.670905263,13.1138246 0.0317473684,16.6554386 C-0.16474386,17.7375439 0.572940351,18.6231579 1.65504561,18.9672982 C3.76985263,19.6067368 7.11469474,19.9997193 10.3124491,19.9997193 C14.5914667,19.9997193 17.2971509,19.6067368 19.215186,18.9181754 C20.1010807,18.573193 20.7402386,17.8357895 20.5928702,16.9010526 Z",
    id: "Stroke-3",
    strokeWidth: 0.7
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccUser);
export default __webpack_public_path__ + "static/media/icAccUser.13f26cff0849a72a853580c0d15298d1.svg";
export { ForwardRef as ReactComponent };